import { PunchStatus, PunchType } from '@construction/shared';
import type { QueueItem, QueueSnapshot } from '@/features/upload-queue';

/**
 * 「这次下班打卡该不该结束会话」的判定（CR-006）。
 *
 * 单独拎出来是因为这两条规则一旦错了，表现都很隐蔽：
 * 判早了 —— 工人被踢出登录，队列里的打卡再也传不上去；
 * 判晚了 —— 手机上留着上一个人的登录态，下一个人顶着他的身份打卡。
 * 两种都不会报错，只会在工资单上体现出来。
 */

/** 这个队列条目是不是一次下班打卡 */
export function isClockOutItem(item: Pick<QueueItem, 'kind' | 'payload'>): boolean {
  return item.kind === 'PUNCH' && item.payload.type === PunchType.OUT;
}

/**
 * 服务端已经给出判定之后，这次下班打卡算不算「人已经走完下班流程」。
 *
 * 被判超出范围（REJECTED）不算：人多半要走近工地再打一次。
 * 这时候把他踢出去，他得重新登录才能补打。
 * 待复核（模拟定位、精度太差）算 —— 他本人确实已经下班了，
 * 记录有没有问题是管理员事后复核的事。
 */
export function shouldEndSessionAfterClockOut(status: string | undefined): boolean {
  return status !== PunchStatus.REJECTED;
}

/**
 * 现在能不能真的退出。
 *
 * 退出会清掉凭证，所以队列里但凡还有没传完的东西就不能退 ——
 * 不光是那条下班打卡，还包括排在它前面的照片和日报。
 * 有传失败的也不退：工人得留在登录态里重试，否则连补救的机会都没有。
 */
export function canLogoutNow(snapshot: Pick<QueueSnapshot, 'pending' | 'uploading' | 'failed'>): boolean {
  return snapshot.pending === 0 && snapshot.uploading === 0 && snapshot.failed === 0;
}
